import * as main from '../main.js'

export const selector = '[data-contract~="field.helpers.errors"]'

const handle = (element, aria) => {
  const [{ name }] = main.handle(element, aria)
  const { dataset } = element
  
  dataset.fieldName = name
}

export default element => {
  handle(element, 'errormessage')
}
